import * as React from "react";

const STRINGS = {
    STOCK: gettext("Stock"),
};

export default class PackageButton extends React.Component {

    constructor(props) {
        super(props);
        this.updateOnClick = this.updateOnClick.bind(this);
    }

    updateOnClick = () => {
        this.props.setPackageSelect(this.props.value, this.props.tank_module);
    };

    onMouseEnter = () => {
        this.props.setNewPackage(this.props.value, this.props.tank_module);
    };
    onMouseLeave = () => {
        this.props.removeNewPackage(this.props.value, this.props.tank_module);
    };
    render() {
        let ITEM_CLASS = "tank-package_item";
        const ITEM_ACTIVE_CLASS = ITEM_CLASS + "__selected";
        const ITEM_NOCHILDREN_CLASS = ITEM_CLASS + "__no-children";

        ITEM_CLASS += this.props.mapping ? "" : " " + ITEM_NOCHILDREN_CLASS;
        ITEM_CLASS += this.props.isActive ? " " + ITEM_ACTIVE_CLASS : "";
        ITEM_CLASS += " js-package-tree_item";
        let tank_ico_selected = this.props.isActive ? "tank-config_ico __selected" : "tank-config_ico";
        let tank_module = this.props.tank_module;
        let moduleName = this.props.moduleName;
        let user_string;
        if(tank_module === "guns") {
            user_string = vehicle.guns[moduleName].user_string;
        } else if(tank_module === "turrets") {
            for(let t of ["turrets0", "turrets1", "turrets2", "turrets3"]) {
                if(vehicle.data[t]) {
                    if(vehicle.data[t][moduleName])
                        user_string = vehicle.data[t][moduleName].user_string;
                }
            }
        } else {
            user_string = vehicle.data[tank_module][moduleName].user_string;
        }

        let tank_package_bg_class =  (this.props.isActive && ((this.props.tank_module === "guns" && !this.props.gunCompatible) || (this.props.tank_module === "turrets" && !this.props.turretCompatible))) ? "tank-package_bg incompatible" : "tank-package_bg";
        let incompatiblility =  (this.props.isActive && ((this.props.tank_module === "guns" && !this.props.gunCompatible) || (this.props.tank_module === "turrets" && !this.props.turretCompatible)));
        return (
            <div className={ITEM_CLASS} data-value={this.props.value} data-mapping={this.props.mapping}
                 onClick={this.updateOnClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <span className={tank_package_bg_class}>
                </span>
                {/*<span className="tank-package_ico">*/}
                    <img className={tank_ico_selected}
                         src={STATIC_URL + "portal/css/scss/tank-page/img/module_icons/"
                         + this.props.icon
                         + String(get_icon_index(this.props.moduleGroupIndex, this.props.componentData.length) + 1)
                         + ".png"}/>
                    {incompatiblility ? (<img className="tank-config_ico warning-check" src={STATIC_URL + "portal/css/scss/tank-page/img/warning.svg"}/> ) : null}
                {/*</span>*/}
                <span className="tank-package_text">
                    <span className="tank-package_title" dangerouslySetInnerHTML={{__html: user_string}}></span>
                    <span className="tank-package_position">{this.props.position ? this.props.position : null}</span>
                    {
                        (this.props.xpCost > 0) &&
                        <span className="tank-package_exp">{this.props.xpCost.toLocaleString()}
                            <span className="svg-icon js-svg-icon"
                                  data-src={ STATIC_URL +"tankopedia/img/svg-icons/exp-bundle.svg"}>
                            </span>
                        </span>
                    }
                </span>
            </div>
        )
    }
}

var icon_indexes = [
    [0],
    [0, 3],
    [0, 2, 3],
    [0, 1, 2, 3],
    [0, 1, 2, 2, 3],
    [0, 1, 1, 2, 2, 4],
    [0, 0, 1, 1, 2, 2, 4]];

function get_icon_index(module_index, module_length){
    return icon_indexes[module_length - 1][module_index];
}

